// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Zp9Y","title":"styles_title__w_Pye"};